export class ApiError extends Error {
  public status?: number;
  public data?: any;

  constructor(message: string, status?: number, data?: any) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

export function handleApiError(error: unknown): ApiError {
  if (error instanceof ApiError) {
    return error;
  }

  if (error instanceof Error) {
    if (error.name === "AbortError") {
      return new ApiError("Request timed out. Please try again.", 408);
    }
    return new ApiError(error.message || "An unexpected error occurred.");
  }

  if (typeof error === "string") {
    return new ApiError(error);
  }

  return new ApiError("An unknown error occurred. Please try again later.");
}

export function formatErrorMessage(error: unknown): string {
  const apiErr = handleApiError(error);
  if (apiErr.status) {
    switch (apiErr.status) {
      case 400:
        return apiErr.message || "Bad Request. Please check your input.";
      case 401:
        return "Session expired. Please log in again.";
      case 403:
        return "Access denied. You do not have permission.";
      case 404:
        return "Requested resource not found.";
      case 500:
        return "Internal server error. Please try again later.";
      default:
        return apiErr.message;
    }
  }
  return apiErr.message;
}

export default handleApiError;
